import { Palette } from '@infoods/lifebase-ui';
import { Plugin } from 'chart.js';

export const getChartBorder = (palette: Palette): Plugin => ({
  id: 'chartBorder',
  beforeDraw({ ctx, chartArea }) {
    ctx.save();
    ctx.strokeStyle = palette.neutral[200];
    ctx.lineWidth = 1;
    ctx.strokeRect(chartArea.left, chartArea.top, chartArea.width, chartArea.height);
    ctx.restore();
  },
});
